function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = { detail: data };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/* ------------------------------------------------------------------
   RED BAR: CSS einmalig injizieren (für Balken links am Textblock)
-------------------------------------------------------------------*/
(function injectRedBarStyles() {
  const EXISTING = document.getElementById('redbar-styles');
  const css = `
    /* Globale Default-Variablen am Container mit .has-red-bar */
    .has-red-bar{
      --bar-width: 12px;                 /* fixe Breite */
      --bar-gap: 22px;                   /* Abstand Text */
      --bar-color: var(--color-accent, #E60000);
      --bar-scale: 1;                    /* 0..1 – animierbar via GSAP */
    }

    /* Balken sitzt direkt an jeder SplitText-Zeile */
    .has-red-bar .line-child{
      display: inline-block !important;  /* übersteuert inline "display:block" von SplitText */
      background-image: linear-gradient(var(--bar-color), var(--bar-color));
      background-repeat: no-repeat;
      background-position: left center;
      background-size: var(--bar-width) calc(1em * var(--bar-scale)); /* Höhe = font-size */
      padding-left: var(--bar-gap);
    }
  `;
  if (EXISTING) {
    EXISTING.textContent = css;
  } else {
    const style = document.createElement('style');
    style.id = 'redbar-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }
})();

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', { bubbles: true });
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;
      if (this.input.getAttribute('min') > (quantity + change)) { return; }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) { return; }
      }
      quantity += change;
      quantity = Math.max(quantity, 1);
      this.input.value = quantity;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.secondary = this.querySelector('.product-secondary-image');
      this.image = this.secondary || this.querySelector('.product-primary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) this.enableSwatches(this.swatches, this.image);
      if (this.quick_add) this.enableQuickAdd();
      if (this.secondary) {
        window.addEventListener('load', () => { lazySizes.loader.unveil(this.secondary); });
      }
      if (this.size_options) this.enableSizeOptions();
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
          org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;
      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, el => el.classList.remove('active'));
          if (image) {
            if (swatch.dataset.srcset) image.setAttribute('srcset', swatch.dataset.srcset);
            else image.setAttribute('srcset', org_srcset);
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      if (this.quick_add.__thbQuickAddBound) return;
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
      this.quick_add.__thbQuickAddBound = true;
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
          featured_image = this.querySelector('.product-featured-image'),
          has_hover = featured_image.classList.contains('thb-hover'),
          size_parent = this.size_options.parentElement;
      this.size_index = this.size_options.dataset.index;
      this.current_options = this.size_options.dataset.options.split(',');
      this.updateMasterId();
      size_parent.addEventListener('mouseenter', () => { if (has_hover) featured_image.classList.remove('thb-hover'); }, { passive: true });
      size_parent.addEventListener('mouseleave', () => { if (has_hover) featured_image.classList.add('thb-hover'); }, { passive: true });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (size.classList.contains('is-disabled')) return;
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();
          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
          };
          let formData = new FormData();
          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) return;
              this.renderContents(response);
              console.log("cart:item-added", "enableSizeOptions");
              dispatchCustomEvent('cart:item-added', { product: response.hasOwnProperty('items') ? response.items[0] : response });
            })
            .catch(console.error)
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => { this.setDisabled(); }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();
      if (variant_data) {
        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => ({ value, index: `option${index + 1}` }));
          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input) => {
              input.classList.add('is-disabled');
            });
          }
        }
      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;
          let entry = options[index].find(option => option.value === variant[index]);
          if (typeof entry === 'undefined') {
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, { value, index }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });
        return options;
      }, { option1: [], option2: [], option3: [] });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.getAttribute('disabled') != undefined) return;
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);
      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
      };
      let formData = new FormData();
      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;
          this.renderContents(response);
          console.log("cart:item-added", "quickAdd");
          dispatchCustomEvent('cart:item-added', { product: response.hasOwnProperty('items') ? response.items[0] : response });
        })
        .catch(console.error)
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });
      return false;
    }
    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) return;
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof Cart !== 'undefined') { new Cart().renderContents(parsedState); }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
      this.panel = this.closest('.side-panel');
      this.addEventListener('click', (e) => this.close_panel(e));
      this.addEventListener('keydown', (e) => this.close_panel(e));
      cc.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', () => {
        let panel = document.querySelectorAll('.side-panel.active, .open-search .search-drawer');
        if (panel.length) this.close_panel({}, panel[0]);
      });
    }
    close_panel(e, side_panel) {
      let panel = this.panel;
      if (e.code && e.code.toUpperCase() !== 'ENTER') return;
      if (side_panel) panel = side_panel;
      if (!panel) panel = document.querySelector('.side-panel.active');
      if (panel) panel.classList.remove('active');
      if (document.body.classList.contains('open-cc--product')) {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => { document.querySelector('#Product-Drawer-Content').innerHTML = ''; }, 260);
      } else if (panel?.classList.contains('cart-drawer') && document.querySelector('.view-products-panel.active')) {
        return;
      } else {
        if (document.body.classList.contains('open-search')) document.body.classList.remove('open-search');
        document.body.classList.remove('open-cc');
      }
      if (document.body.classList.contains('overflow-hidden')) document.body.classList.remove('overflow-hidden');
    }
  }
  customElements.define('side-panel-close', PanelClose);
  document.addEventListener('keyup', (e) => {
    if (e.code && e.code.toUpperCase() === 'ESCAPE') dispatchCustomEvent('panel:close');
  });
}

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.button = document.getElementById('cart-drawer-toggle');
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.classList.add('active');
      this.focus();
      setTimeout(() => { window.dispatchEvent(new Event('resize')); });
      dispatchCustomEvent('cart-drawer:open');
    });
    this.debouncedOnChange = debounce((event) => { this.onChange(event); }, 300);
    document.addEventListener('cart:refresh', () => { this.refresh(); });
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) this.updateQuantity(event.target.dataset.index, event.target.value);
  }
  removeProductEvent() {
    let removes = this.querySelectorAll('.remove');
    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');
        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer-inner' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.querySelector('#CartDrawerTerms'),
        checkout_button = this.querySelector('.button.checkout');
    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = this.querySelector('#order-note-toggle');
    if (!notes_toggle) return;
    notes_toggle.addEventListener('click', () => { notes_toggle.nextElementSibling.classList.add('active'); });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', () => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      body: JSON.stringify({ 'note': document.getElementById('mini-cart__notes').value })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.querySelector('.free-shipping');
    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      if (total < minimum) {
        percentage = total / minimum;
        if (amount_text) {
          let remaining = minimum - total,
              format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }
      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
    const body = JSON.stringify({
      line, quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', { quantity: quantity });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      ...{ body }
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', { quantity: quantity, cart: parsedState });
        if (this.querySelector(`#CartDrawerItem-${line}`)) {
          this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
      });
  }
}
customElements.define('cart-drawer', CartDrawer);

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.hide.bind(this));
      this.closeButton.addEventListener('keyup', (event) => { if (event.code.toUpperCase() === 'ENTER') this.hide(); });
    }
    this.addEventListener('keyup', (event) => { if (event.code.toUpperCase() === 'ESCAPE') this.hide(); });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => { if (event.target.nodeName === 'MODAL-DIALOG') this.hide(); });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    if (this.dataset.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    setTimeout(() => { this.querySelector('[role="dialog"]').focus(); }, 100);
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => { video.contentWindow.postMessage('{"method":"pause"}', '*'); });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    window.addEventListener('load', () => { document.querySelectorAll('.resize-select').forEach(_this.resizeSelect); });
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) _this.resizeSelect(e.target);
    });
    window.addEventListener('resize.resize-select', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }
  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;
    let tempSelect = document.createElement('select'), offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) { offset = 2; }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) { sel.style.width = `${+tempSelect.clientWidth + offset}px`; }
    tempSelect.remove();
  }
}
if (typeof SelectWidth !== 'undefined') { new SelectWidth(); }

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;
      if (this.dataset.productHandle) {
        this.addEventListener('click', this.setupEventListener.bind(this));
        if (this.cc) this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
      }
    }
    setupCCEventListener() {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');
      setTimeout(() => { this.drawer.querySelector('#Product-Drawer-Content').innerHTML = ''; }, 260);
    }
    setupEventListener(e) {
      if (!this.dataset.productHandle) return;
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
          href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
      if (this.disabled) return;
      href = href.replace('//', '/');
      if (!href || !productHandle) return;
      if (this.classList.contains('loading')) return;
      this.classList.add('loading');
      fetch(href, { method: 'GET' })
        .then((response) => { this.classList.remove('loading'); return response.text(); })
        .then(text => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#Product-Drawer-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');
        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }
        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) { Shopify.PaymentButton.init(); }
          if (window.ProductModel) { window.ProductModel.loadShopifyXR(); }
        }, 300);
        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();
        dispatchCustomEvent('quick-view:open', { productUrl: href, productHandle: productHandle });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
    connectedCallback() { this.setListeners(); }
    setListeners() { this.querySelector('summary').addEventListener('click', (e) => this.onClick(e)); }
    instantClose() { this.tl?.timeScale(10).reverse(); }
    animateClose() { this.tl?.timeScale(3).reverse(); }
    animateOpen() { this.tl?.timeScale(1).play(); }
    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = 'hidden';
      if (this.isClosing || !this.details.open) { this.open(); }
      else if (this.isExpanding || this.details.open) { this.shrink(); }
    }
    shrink() {
      this.isClosing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: 250, easing: 'ease' });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');
    if (product) handle = product.dataset.handle;
  }
  if (!handle) return;
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  var i = window.recentlyViewedIds.indexOf(handle);
  if (i > -1) { window.recentlyViewedIds.splice(i, 1); }
  window.recentlyViewedIds.unshift(handle);
  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Animations (ScrollTrigger)
 */
if (window.ScrollTrigger && window.gsap) {
  ScrollTrigger.batch('.animations-true .products .gallery--item figure, .animations-true .product-card .product-featured-image-link', {
    start: "top 90%",
    onEnter: (elements) => { gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing }); }
  });
  ScrollTrigger.batch('.animations-true .multicolumn--column-inner', {
    start: "top 90%",
    onEnter: (elements) => { gsap.to(elements, { y: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing }); }
  });
  ScrollTrigger.batch('.animations-true .blog-post .featured-image--link', {
    start: "top 90%",
    onEnter: (elements) => { gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing }); }
  });
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', () => { button.classList.toggle('active'); });
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') { new FooterMenuToggle(); }
});

/* --------- Dynamische Balken für diverse Überschriften (bestehend) --------- */
function adjustAllBars() {
  // Helper: dynamische Balken mit robuster Zeilen-Erkennung
  const setDynamicBar = (el, {
    inline = false,
    color = 'var(--color-accent, #E60000)',
    barWidth = 12,
    gap = 22,
    topOffset = 2,
    singleFactor = 0.7,   // Einzeilig (Fallback, font-size-basiert)
    twoLineFactor = 0.90,  // Zweizeilig (Block-basiert)
    useLHForSingle = false,
    singleLHFactor = 0.36, // Einzeilig (line-height-basiert, wenn useLHForSingle)
    scaleVar = '--bar-scale',
    forceImportant = false // <- NEU: setzt background-size/-position mit !important
  } = {}) => {
    const cs       = getComputedStyle(el);
    const fontSize = parseFloat(cs.fontSize) || 16;
    const scale    = Number.parseFloat(cs.getPropertyValue(scaleVar)) || 1;

    // Zeilen & reiner Text-Block via Range messen (ignoriert Padding)
    let lines = 1, contentTopOffset = 0, contentHeight = el.scrollHeight, lineHeight;
    try {
      const range = document.createRange();
      range.selectNodeContents(el);
      const rects = Array.from(range.getClientRects()).filter(r => r.width > 0 && r.height > 0);
      if (rects.length) {
        lines = rects.length;
        const first = rects[0], last = rects[rects.length - 1], elRect = el.getBoundingClientRect();
        contentTopOffset = Math.max(0, first.top - elRect.top);
        contentHeight    = Math.max(0, last.bottom - first.top);
        lineHeight       = contentHeight / lines;
      }
    } catch(e) {}

    if (!Number.isFinite(lineHeight)) {
      lineHeight = Number.parseFloat(cs.lineHeight);
      if (!Number.isFinite(lineHeight)) lineHeight = fontSize * 1.2; // Fallback
    }

    let barH, posY;

    if (lines === 1) {
      const base = useLHForSingle ? (lineHeight * singleLHFactor) : (fontSize * singleFactor);
      barH = Math.max(base * scale, 0);
      posY = contentTopOffset + Math.max((lineHeight - barH) / 2, 0) + topOffset;
    } else if (lines === 2) {
      const blockH = Math.max(contentHeight - topOffset * 2, 0);
      barH = Math.max(blockH * twoLineFactor, 0);
      posY = contentTopOffset + topOffset + (blockH - barH) / 2;
    } else {
      barH = Math.max(contentHeight - topOffset * 2, 0);
      posY = contentTopOffset + topOffset;
    }

    el.style.backgroundImage  = `linear-gradient(${color}, ${color})`;
    el.style.backgroundRepeat = 'no-repeat';

    const bSize = `${barWidth}px ${barH}px`;
    const bPos  = `left ${posY}px`;

    if (forceImportant) {
      el.style.setProperty('background-size', bSize, 'important');
      el.style.setProperty('background-position', bPos, 'important');
    } else {
      el.style.backgroundSize     = bSize;
      el.style.backgroundPosition = bPos;
    }

    el.style.paddingLeft = `${gap}px`;
    if (inline) el.style.display = 'inline-block';

    // Falls CSS background-size: 12px var(--bar-height) nutzt:
    el.style.setProperty('--bar-height', `${barH}px`);
  };

  /* 1) Statisch geblieben */
  ['.list-collections.overlay .collection-card--content a'].forEach((selector) => {
    document.querySelectorAll(selector).forEach(element => {
      const textHeight = element.scrollHeight;
      const barHeight  = Math.max(textHeight * 0.6, 12);
      element.style.backgroundImage  = 'linear-gradient(var(--color-accent, #E60000), var(--color-accent, #E60000))';
      element.style.backgroundSize   = `12px ${barHeight}px`;
      element.style.backgroundRepeat = 'no-repeat';
      element.style.backgroundPosition = 'left center';
      element.style.paddingLeft      = '22px';
    });
  });

  /* 2) Slide-Headings (dynamisch) */
  document.querySelectorAll('.background-video__content .h1-large').forEach(el => {
    setDynamicBar(el, { inline: true });
  });
  document.querySelectorAll('.slideshow__slide-heading').forEach(el => {
    setDynamicBar(el, { inline: true });
  });

  /* 3) Section-Header H2 (wie Slides) */
  document.querySelectorAll('.section-header h2').forEach(el => {
    setDynamicBar(el);
  });

  /* 3b) Template-Header-Titel (wie Slides) */
  document.querySelectorAll('.template-header--title.template-header--title-uppercase-false').forEach(el => {
    el.style.display = 'inline-block';
    el.style.margin  = '0 auto';
    setDynamicBar(el, { singleFactor: 0.70, twoLineFactor: 0.92, topOffset: 0 });
  });

  /* 3c) Gallery Item Heading – mit !important + var Sync */
  document.querySelectorAll('.gallery--item-content .gallery--item--heading').forEach(wrap => {
  // alte Inline-Styles am Wrapper entfernen, damit wir nur auf dem Text rendern
  wrap.style.backgroundImage = 'none';
  wrap.style.backgroundSize = '';
  wrap.style.backgroundPosition = '';
  wrap.style.paddingLeft = '';

  // Ziel: der reine Text (Fallback = wrap, falls .heading-text fehlt)
  const textEl = wrap.querySelector('.heading-text') || wrap;

  setDynamicBar(textEl, {
    inline: true,
    singleFactor: 0.70,   // Einzeilig-Höhe (ggf. feintunen)
    twoLineFactor: 0.92,  // Zweizeilig-Höhe
    topOffset: 1,
    forceImportant: true  // überstimmt evtl. Theme-Regeln
  });
});

  /* 3d) Post-Title H1 */
  document.querySelectorAll('.post-title h1').forEach(el => {
    setDynamicBar(el, { inline: true, singleFactor: 0.70, twoLineFactor: 0.92, topOffset: 1 });
  });

  /* 3e) Policy-Title H1 */
  document.querySelectorAll('.shopify-policy__title h1').forEach(el => {
    setDynamicBar(el, { inline: true, singleFactor: 0.70, twoLineFactor: 0.92, topOffset: 1 });
  });

  /* 4) Image-with-Text Headings */
  document.querySelectorAll('.image-with-text-slideshow--heading').forEach(el => {
    setDynamicBar(el);
  });

  /* 5) Footer Email Bar (.h4) – einzeilig schlank, zweizeilig kompakter, vertikal zentriert */
  document.querySelectorAll('.footer-email-bar .h4').forEach(el => {
    setDynamicBar(el, {
      color: '#E60000',
      useLHForSingle: true,
      singleLHFactor: 0.75,
      twoLineFactor: 0.88,
      singleFactor: 0.56,
      topOffset: 0
    });
    el.style.backgroundPosition = 'left center';
  });

  /* 6) Rest (CSS-Varianten) – var für Themes, die --bar-height nutzen */
  document.querySelectorAll('.gallery--item--heading').forEach(heading => {
    const textHeight = heading.scrollHeight;
    const barHeight  = Math.max(textHeight * 0.8, 12);
    heading.style.setProperty('--bar-height', `${barHeight}px`);
  });

  document.querySelectorAll('.rich-text__inner h1, .rich-text__inner h2, .rich-text__inner h3').forEach(heading => {
    const originalDisplay = heading.style.display;
    const originalJustify = heading.style.justifyContent;
    heading.style.display = 'block';
    heading.style.textAlign = 'center';
    const textHeight = heading.scrollHeight;
    const barHeight  = Math.max(textHeight * 0.9, 12);
    heading.style.display = originalDisplay || 'flex';
    heading.style.justifyContent = originalJustify || 'center';
    heading.style.setProperty('--rich-text-bar-height', `${barHeight}px`);
  });

  document.querySelectorAll('.email-signup--inner .h1').forEach(heading => {
    const originalDisplay = heading.style.display;
    const originalJustify = heading.style.justifyContent;
    heading.style.display = 'block';
    heading.style.textAlign = 'left';
    const textHeight = heading.scrollHeight;
    const barHeight  = Math.max(textHeight * 0.9, 12);
    heading.style.display = originalDisplay || 'flex';
    heading.style.justifyContent = originalJustify || 'center';
    heading.style.setProperty('--email-signup-bar-height', `${barHeight}px`);
  });
}


// Events
document.addEventListener('DOMContentLoaded', adjustAllBars);
window.addEventListener('resize', (() => {
  let t; return () => { clearTimeout(t); t = setTimeout(adjustAllBars, 120); };
})());
if (document.fonts && document.fonts.ready) document.fonts.ready.then(adjustAllBars);
setTimeout(adjustAllBars, 300);

/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      const slideshow = this;
      let
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        pageDots = slideshow.dataset.dots == 'true' ? true : false,
        prev_buttons = slideshow.querySelectorAll('.flickity-prev'),
        next_buttons = slideshow.querySelectorAll('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-dots'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar:not(.slideshow--autoplay-progress)'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {}
        };
      this.paused = false;
      if (custom_dots) { args.pageDots = false; args.pauseAutoPlayOnHover = false; }
      if (slideshow.dataset.adapt == 'true') { args.adaptiveHeight = true; }
      if (slideshow.classList.contains('customer-reviews--carousel')) { args.wrapAround = true; args.resize = true; }
      if (slideshow.classList.contains('collection-grid__carousel') || slideshow.classList.contains('product-images-quick-view')) { args.wrapAround = false; }

      // Main Slideshow
      if (slideshow.classList.contains('main-slideshow')) {
        if (animations_enabled) { slideshow.prepareAnimations(slideshow, animations); }
        args.on = {
          staticClick: function () { this.unpausePlayer(); },
          ready: function () {
            let flkty = this;
            if (header?.classList.contains('transparent--true')) {
              let i = slideshow.dataset.sectionIndex;
              if (Shopify.designMode) {
                let children = [...slideshow.closest('.shopify-section').parentNode.children];
                i = children.indexOf(slideshow.closest('.shopify-section')) + 1;
              }
              if (i == 1 && slideshow.classList.contains('section-spacing--disable-top')) {
                slideshow.classList.add('slideshow--top');
              }
              if (i == 1 && slideshow.classList.contains('change-header--true')) {
                let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text');
                header.style.setProperty('--color-header-transparent-text', color_text);
              }
            }
            if (animations_enabled) { slideshow.animateSlides(0, slideshow, animations); }
            document.fonts.ready.then(function () { flkty.resize(); });
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () { slideshow.videoPlay(video_container); };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () { slideshow.videoPlay(video_container); };
              }
            }
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => { dot.addEventListener('click', () => { flkty.select(i); }); });
              dots[this.selectedIndex].classList.add('is-selected');
            }
          },
          change: function (index) {
            let flkty = this,
                previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text'),
                color_text_rgb = getComputedStyle(this.selectedElement).getPropertyValue('--color-text-rgb');
            if (animations_enabled) {
              slideshow.style.setProperty('--color-text', color_text);
              slideshow.style.setProperty('--color-text-rgb', color_text_rgb);
            }
            if (header && header.classList.contains('transparent--true')) {
              let i = slideshow.dataset.sectionIndex;
              if (Shopify.designMode) {
                let children = [...slideshow.closest('.shopify-section').parentNode.children];
                i = children.indexOf(slideshow.closest('.shopify-section')) + 1;
              }
              if (i == 1 && slideshow.classList.contains('change-header--true')) {
                header.style.setProperty('--color-header-transparent-text', color_text);
              }
            }
            if (autoplay) {
              if (flkty.player.state !== 'paused') { flkty.stopPlayer(); flkty.playPlayer(); }
            }
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) { slideshow.videoPause(video_container_prev); }
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot) => { dot.classList.remove('is-selected'); });
              dots[this.selectedIndex].classList.add('is-selected');
            }
          }
        };
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }

      // Testimonials
      if (slideshow.classList.contains('testimonials--carousel')) {
        args.on = {
          ready: function () {
            let flkty = this;
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => { dot.addEventListener('click', () => { flkty.select(i); }); });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            if (autoplay && autoplay_progress) { slideshow.setupAutoplayProgress(slideshow, autoplay_progress); }
          },
          change: function () {
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot) => { dot.classList.remove('is-selected'); });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            if (autoplay && autoplay_progress) {
              slideshow.autoPlayProgressTL.progress(0);
              if (this.player.state !== 'paused') { slideshow.autoPlayProgressTL.play(); }
            }
          }
        };
      }

      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          let flickity = this;
          if (next_buttons.length) {
            window.addEventListener('resize.center_arrows', function () {
              slideshow.centerArrows(flickity, slideshow, prev_buttons[0], next_buttons[0]);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = (progress * 100) + '%';
        };
      }

      const flkty = new Flickity(slideshow, args);
      selectedIndex = flkty.selectedIndex;
      slideshow.dataset.initiated = true;

      if (prev_buttons) {
        prev_buttons.forEach(function (prev_button) {
          prev_button.addEventListener('click', () => { document.dir === 'rtl' ? flkty.next() : flkty.previous(); });
          prev_button.addEventListener('keyup', () => { document.dir === 'rtl' ? flkty.next() : flkty.previous(); });
        });
        next_buttons.forEach(function (next_button) {
          next_button.addEventListener('click', () => { document.dir === 'rtl' ? flkty.previous() : flkty.next(); });
          next_button.addEventListener('keyup', () => { document.dir === 'rtl' ? flkty.previous() : flkty.next(); });
        });
      }
      if (Shopify && Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }
      this.addEventListener('change', this.reInit.bind(this));
    }
    reInit() { this.reloadCells?.(); }

    setupAutoplayProgress(slideshow, autoplay_progress) {
      slideshow.autoPlayProgressTL = gsap.timeline({ inherit: false });
      slideshow.autoPlayProgressTL
        .fromTo(autoplay_progress, { scaleX: 0 }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          scaleX: 1,
          ease: 'linear'
        });
      slideshow.addEventListener('mouseenter', function () { slideshow.autoPlayProgressTL.pause().progress(0); });
      slideshow.addEventListener('mouseleave', function () { slideshow.autoPlayProgressTL.play(); });
    }

    videoPause(video_container) {
      setTimeout(() => { video_container.querySelector('video').pause(); }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => { video_container.querySelector('video').play(); }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {

        /* --- RED BAR: Ziel-Elemente markieren --- */
        slideshow.querySelectorAll('.slideshow__slide-heading, p.split-text')
          .forEach(el => el.classList.add('has-red-bar'));

          /*
        let splittext = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-child'
        });
        let mask = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-parent'
        });
        */

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({ paused: true }),
              button_offset = 0;
          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl.to(item, { duration: 0.7, clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)" }, "start");
          }
          if (slideshow.dataset.transition == 'zoom') {
            tl.to(item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'), { duration: 1.5, scale: 1 }, "start");
          }

          /* --- RED BAR: optional animiert einblenden --- */
          item.querySelectorAll('.slideshow__slide-heading, p.split-text').forEach(el => {
            gsap.set(el, { '--bar-scale': 0 });
            tl.to(el, { duration: 0.45, '--bar-scale': 1, ease: 'power2.out' }, 0);
          });

          if (item.querySelector('.subheading')) {
            tl.fromTo(item.querySelector('.subheading'), { opacity: 0 }, { duration: 0.5, opacity: 1 }, 0);
            button_offset += 0.5;
          }
          if (item.querySelector('.slideshow__slide-heading')) {
            let h1_duration = 1 + ((item.querySelectorAll('.slideshow__slide-heading .line-child').length - 1) * 0.1);
            tl
              .set(item.querySelectorAll('.slideshow__slide-heading'), { opacity: 1 }, 0)
              .from(item.querySelectorAll('.slideshow__slide-heading .line-child'), { duration: h1_duration, yPercent: 120, stagger: 0.1 }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p.split-text')) {
            let p_duration = 1 + ((item.querySelectorAll('p.split-text .line-child').length - 1) * 0.05);
            tl
              .set(item.querySelectorAll('p.split-text'), { opacity: 1 }, 0)
              .from(item.querySelectorAll('p:not(.subheading) .line-child'), { duration: p_duration, yPercent: '120', stagger: 0.1 }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button, .text-button')) {
            tl.fromTo(item.querySelectorAll('.button, .text-button'), { autoAlpha: 0 }, { duration: 0.5, stagger: 0.1, autoAlpha: 1 }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      document.fonts.ready.then(function () { animations[i].restart(); });
    }
    animateReverse(i, slideshow, animations) { animations[i].reverse(); }
    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_cell = flickity.cells[0], max_height = 0, image_height = 0;
      if (first_cell.element.querySelector('.product-featured-image')) {
        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;
      } else if (first_cell.element.querySelector('.gallery--item')) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }
      if (image_height > 0) {
        flickity.cells.forEach((item) => { if (item.size.height > max_height) { max_height = item.size.height; } });
        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;
          prev_button.style.transform = 'translateY(' + difference + 'px)';
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('slide-show', SlideShow);
}
